import React, { Component } from "react";
import { Modal, Form, Col } from "react-bootstrap";
import AppModal from "../../../UI/AppModal/AppModal";
import Button from "../../../UI/Button/Button";
import { inject, observer } from "mobx-react";

@inject("sharedStore")
@observer
class ShareAllCustomers extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };

    }


    shareFile = ()=> {
        this.props.sharedStore.showLoader();
        return this.props.sharedStore.sendHotFix(this.props.selectedHotFixId)
            .then((res) => {
                this.props.sharedStore.hideLoader();
                if (res.status_code === 200) {
                 console.log('res',res)
                    this.props.setToastData(
                        "success",
                        res.message
                    );
                }
                this.props.sharedStore.getHotFixList()
                this.props.sharedStore.fetchCompanyHotFixList(this.props.selectedHotFixId)
                this.props.modalHandler()
            })
            .catch((err) => {
                this.props.sharedStore.hideLoader();
                this.props.setToastData("error", "Internal Server Error");
            });
    }

    render() {
        return (
            <AppModal
                showModal={this.props.modalVisibility}
                modalHandler={this.props.modalHandler}
                modalCeneterd={true}
                dialogCustomClass="form-modal custom_build"
                modalSize="md"
                modalBackdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title as="h5">Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Row>
                            <Col xs={12} sm={12} md={12}>
                                <span>Are you sure you want to share {this.props.selectedHotFix} with all Izenda 7 series customers?</span>
                            </Col>
                        </Form.Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>

                    <Button
                        btnVariant="primary"
                        btnClass="app-btn"
                        clickHandler={this.shareFile}
                    >
                        Yes, Send
          </Button>
                    <Button btnVariant="secondary" clickHandler={this.props.modalHandler}>
                        Cancel
          </Button>
                </Modal.Footer>
            </AppModal>
        );
    }
}

export default ShareAllCustomers;
